import type { useViewerStore } from '@/shared/store/viewer-store';

type ViewerSaveStatus = ReturnType<typeof useViewerStore.getState>['moduleSaveStatus'];

/** Reload is safe only after every persisted editor owner reports clean. */
export function shouldReloadForServiceWorker(status: ViewerSaveStatus, draftDirty: boolean): boolean {
  return !draftDirty && (status === 'idle' || status === 'saved');
}
